import React, { useEffect, useState } from 'react';
import { AppBar, Badge, Toolbar, Typography, Button, Box } from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { signOut, fetchAuthSession } from '../auth';
import { clearCachedProfile } from '../api/users';
import { useCart } from '../context/CartContext';

export default function NavBar() {
  const navigate = useNavigate();
  const { itemCount } = useCart();
  const [email, setEmail] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    fetchAuthSession().then(s => setEmail(s.tokens?.idToken?.payload?.email || '')).catch(() => {});
  }, []);

  async function handleLogout() {
    await signOut();
    clearCachedProfile();
    navigate('/login');
  }

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 0, mr: 4 }}>
          Intervision
        </Typography>
        <Box sx={{ flexGrow: 1, display: 'flex', gap: 2 }}>
          <Button color="inherit" component={Link} to="/catalog">{t('nav.catalog')}</Button>
          <Button color="inherit" component={Link} to="/courses">{t('nav.courses')}</Button>
          <Button color="inherit" component={Link} to="/cart">
            <Badge badgeContent={itemCount} color="error">{t('nav.cart')}</Badge>
          </Button>
          <Button color="inherit" component={Link} to="/orders">{t('nav.orders')}</Button>
        </Box>
        {email && <Typography variant="body2" sx={{ mr: 2, opacity: 0.85 }}>{email}</Typography>}
        <Button color="inherit" onClick={handleLogout}>{t('nav.logout')}</Button>
      </Toolbar>
    </AppBar>
  );
}
